export default class BulkTagsService {
/** @ngInject **/
  constructor(
    $http,
    ngAuthSettings,
    utils
  ) {
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.utils = utils;
  }

  getBulkTags(accountId) {
    const url = this._serviceBaseUrl(accountId);
    return this.$http.get(url);
  }

  uploadValues(accountId, file, zipCodeUploadSettings) {
    return this.utils.readFileContent(file).then((content) => {
      const body = {
        csv_list: content,
        name: file.name
      };

      if (zipCodeUploadSettings) {
        body.zipCodeUploadSettings = {
          convertToAreaCode: zipCodeUploadSettings.convertToAreaCode ? zipCodeUploadSettings.convertToAreaCode : false,
          storeOriginalZipcodes: zipCodeUploadSettings.storeOriginalZipcodes ? zipCodeUploadSettings.storeOriginalZipcodes : true
        };
      }

      const url = this._serviceBaseUrl(accountId);
      return this.$http.post(url, body);
    });
  }

  checkTagExistsInUpload(accountId, tag, bulkTagUploadId) {
    const url = `${this._serviceBaseUrl(accountId, bulkTagUploadId)}/test/${encodeURIComponent(tag)}`;
    return this.$http.get(url);
  }

  deleteBulkTags(accountId, bulkTagUploadId) {
    const url = this._serviceBaseUrl(accountId, bulkTagUploadId);
    return this.$http.delete(url);
  }

  getBulkTagsUrl(accountId, bulkTagUploadId) {
    const url = this._serviceBaseUrl(accountId, bulkTagUploadId) + '/url';
    return this.$http.get(url);
  }

  getBulkTagsReferences(accountId, bulkTagUploadId) {
    const url = this._serviceBaseUrl(accountId, bulkTagUploadId) + '/InboundReferences';
    return this.$http.get(url);
  }

  _serviceBaseUrl(accountId, bulkTagUploadId) {
    return this.ngAuthSettings.apiServiceBaseUri + accountId + '/bulkTags' + (bulkTagUploadId ? '/' + bulkTagUploadId : '');
  }
}